import React from 'react';
import { SVGProps } from './types';

function BankAccountIcon(props: SVGProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
        d="M11.996 7.013h.01M4 10.008v8.495m4-8.495v8.495M16 10.008v8.495m4-8.495v8.495M22 18.503H2V22h20v-3.498z"
      />
      <path
        stroke="currentColor"
        d="M2.006 7.012L11.984 2a.01.01 0 01.01 0l10 5.012a.01.01 0 01.006.009v2.987H2V7.02a.01.01 0 01.006-.009z"
      />
    </svg>
  );
}

export { BankAccountIcon };
